define([
    "jquery",
    "underscore",
    "backbone",
    "aos"
], function($, _, Backbone, AOS) {

    window.addEventListener("load", function(){
        AOS.init();
    })

    return Backbone.View.extend({
        el: '#content_layout',

        initialize: function(){

        },

    });
});